'use client';
/** @jsxImportSource @emotion/react */

import { useCallback, useState } from 'react';

export function useForceUpdate() {
  const [, setUpdate] = useState(0);

  return useCallback(() => {
    setUpdate((n) => n + 1);
  }, [setUpdate]);
}
